const obj = {
  ADD: 'fas fa-plus',
  SHOW: 'fa fa-eye',
  EDIT: 'fa fa-edit',
  VALIDATE: 'fas fa-thumbs-up',
  REFUSE: 'fas fa-thumbs-down',
  RESET: 'fas fa-times',
  DOCUMENT: 'fa fa-paperclip',
  STATUT: 'mdi mdi-checkbox-blank-circle',
  EMBAUCHER: 'fa fa-share-square',
};

export const datatable = {
  ICON_STATUT: obj.STATUT,
  ICON_SEARCH: 'mdi-magnify',
  ICON_CLONE: 'fa fa-clone',
  ICON_SHOW: obj.SHOW,
  ICON_EDIT: obj.EDIT,
  ICON_DELETE: 'fa fa-trash',
};

export const editLayout = {
  ICON_SHOW: obj.SHOW,
  ICON_ADD: obj.ADD,
  ICON_VALIDATE: obj.VALIDATE,
  ICON_REFUSE: obj.REFUSE,
  ICON_RESET: obj.RESET,
  ICON_EDIT: obj.EDIT,
  ICON_DOCUMENT: obj.DOCUMENT,
  ICON_STATUT: obj.STATUT,
  ICON_EMBAUCHER: obj.EMBAUCHER,
};

export const show = {
  ICON_CALENDAR: 'far fa-calendar',
  ICON_INFO: 'fa fa-info-circle',
  ICON_USER: 'far fa-user',
  ICON_COMMENT: 'far fa-comments',
};

export const showLayout = {
  ICON_ADD: obj.ADD,
  ICON_EDIT: obj.EDIT,
  ICON_SHOW: obj.SHOW,
  ICON_VALIDATE: obj.VALIDATE,
  ICON_REFUSE: obj.REFUSE,
  ICON_RESET: obj.RESET,
  ICON_DOCUMENT: obj.DOCUMENT,
  ICON_STATUT: obj.STATUT,
  ICON_EMBAUCHER: obj.EMBAUCHER,
};
